module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 6-cd7020c39a319863af4e6aecf8c44e26.jpg";